import { GlobalDesignAction } from '../types';
import { fillGrouping } from './grouping';
import DefaultLobbyItem from '../common/lobby/DefaultLobbyItem';
import FillStyles from './FillStyles';

const fillAction: GlobalDesignAction<'fillStyles'> = {
  panel: FillStyles,
  lobbyItem: DefaultLobbyItem,
  grouping: fillGrouping,
};

export default fillAction;
